import React from 'react'
import StarRounded from '@mui/icons-material/StarRounded'
import { categoryMeta, FallbackIcon, homeworkStatusLabel } from './constants'
import { normalizeQuestStatus, questProgressLabel } from './quest/questTypes'

function formatDeadline(deadline) {
  if (!deadline) return ''
  const date = new Date(deadline)
  if (Number.isNaN(date.getTime())) return String(deadline)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}`
}

function formatScore(score) {
  if (score == null || Number.isNaN(Number(score))) return ''
  const n = Number(score)
  return Number.isInteger(n) ? String(n) : n.toFixed(1)
}

export default function ResourceCard({ item, onLaunch, onOpenHomework, onOpenEvaluation }) {
  const meta = categoryMeta[item.assetType] || {
    label: item.assetType,
    Icon: FallbackIcon,
  }
  const Icon = meta.Icon
  const intro = typeof item.note === 'string' ? item.note.trim() : ''
  const canLaunch = Boolean(item.launchKind)
  const isQuest = Boolean(item.taskId || item.assignmentStatus || item.progress?.assignmentStatus)
  const statusText = isQuest
    ? (questProgressLabel(item)
      || homeworkStatusLabel(item.assignmentStatus || item.progress?.assignmentStatus))
    : ''
  const deadlineText = formatDeadline(item.deadline)
  const showLaunch = isQuest ? canLaunch : true
  const showHomework = isQuest
  const evalSummary = item.evaluationSummary
  const isEvaluated = normalizeQuestStatus(
    item.progress?.status,
    item.assignmentStatus || item.progress?.assignmentStatus,
  ) === 'evaluated'
  const scoreText = isEvaluated ? formatScore(evalSummary?.score) : ''
  const showFullEval = isEvaluated && evalSummary?.hasFullEvaluation

  return (
    <article className={`portal-resource-card${item.isHighlight ? ' highlight' : ''}`}>
      <div className="portal-card-top">
        <span className={`portal-type-badge type-${item.assetType || 'unknown'}`}>
          <Icon className="badge-icon" />
          {meta.label}
        </span>
        {statusText ? (
          <span className="portal-card-status">{statusText}</span>
        ) : null}
        {scoreText ? (
          <span className="portal-card-score">{scoreText} 分</span>
        ) : null}
        {item.isHighlight ? (
          <span className="portal-highlight-star" title="推荐" aria-label="推荐">
            <StarRounded />
          </span>
        ) : null}
      </div>
      <h4 className="portal-card-title">{item.title}</h4>
      <p className="portal-card-desc">{item.description || item.content || '暂无资源说明'}</p>
      {deadlineText ? (
        <p className="portal-card-meta">截止：{deadlineText}</p>
      ) : null}
      {isEvaluated && evalSummary?.comment ? (
        <p className="portal-card-meta">评价：{evalSummary.comment}</p>
      ) : null}
      {intro ? (
        <div className="portal-card-intro">
          <span className="portal-card-intro-label">{isQuest ? '教师说明' : '教师介绍'}</span>
          <p className="portal-card-intro-text">{intro}</p>
        </div>
      ) : null}
      <div className="portal-card-actions">
        {showLaunch ? (
          <button type="button" className="portal-card-action" onClick={() => onLaunch(item)}>
            开始训练
          </button>
        ) : null}
        {showFullEval ? (
          <button
            type="button"
            className={`portal-card-action${showLaunch ? ' is-secondary' : ''}`}
            onClick={() => onOpenEvaluation?.(item)}
          >
            查看完整评价
          </button>
        ) : null}
        {showHomework ? (
          <button
            type="button"
            className={`portal-card-action${(showLaunch || showFullEval) ? ' is-secondary' : ''}`}
            onClick={() => onOpenHomework?.(item)}
          >
            查看作业
          </button>
        ) : null}
      </div>
    </article>
  )
}
